/*
 * @Description: 抽离rec-feeds.vue组件的灯塔上报逻辑(不处理任何业务逻辑)
 * @Author: fiveonelei
 * @Date: 2022-03-25 17:06:53
 * @FilePath: /vise/packages/app-share/src/composable/use-compoent-report-methods/rec-feeds-report.ts
 */
import { computed, Ref, watch } from 'vue';
import { useStore } from '@/store/index';
import { ModelMetaFeed } from '@/types/model';
import useGetCommonMethods from '@/composable/use-get-common-method';
import { report } from '@/libs/report';
import { EMiniAppPosition } from '@/constants/mini-app';
import { ZzConfig } from '@/types/services/fetch-zz-config';
import { IHashMap } from '@/types/data';
import { IS_SSR } from '@/utils/env';

type Params = {
  zzConfig: Ref<null | ZzConfig>,
  recFeeds: Ref<ModelMetaFeed[]>,
  showRec: Ref<boolean>
  currentRecFeedPageData?: Ref<ModelMetaFeed[]>,
};

export default function userRecFeedsReport(params: Params) {
  const { state } = useStore();
  const { getMiniAppReportValue } = useGetCommonMethods();
  const configRecPage = computed(() => params.zzConfig?.value?.recPage);

  const videoReportFormat = (tagName: string) => {
    let reportNum = null;
    const videoTagReportMap = configRecPage.value?.videoTagReportMap || [];

    if (!tagName || !videoTagReportMap.length) {
      return;
    }
    videoTagReportMap.find((o) => {
      if (o.tagKey === tagName) {
        reportNum = o.tagValue;
        return true;
      }
      return false;
    });
    return reportNum;
  };
  const reportRecVideo = (list?: ModelMetaFeed[]) => {
    const recFeedsList = list || params.recFeeds.value;
    const { growthTestData } = state;
    recFeedsList.forEach((feed, index) => {
      report('recommend.video.exposure', {
        type: {
          feed_id: feed.id,
          num: index + 1,
          video_Source: growthTestData?.dataSource,
          video_tag: videoReportFormat(feed?.feedRecommendReason) || null,
          jump_miniApp: getMiniAppReportValue(EMiniAppPosition.recommendVideo),
        },
      });
    });
  };
  watch(params.showRec, (value) => {
    if (IS_SSR) return;
    if (value) {
      reportRecVideo();
      report('recommend.open.exposure');
    }
  });
  const recFeedsReport = {
    onClickFeed(feed: ModelMetaFeed, index: number) {
      const { growthTestData, isWsInstalled, isFullScreen } = state;
      report('recommend.video.click', {
        is_pull_pos: isWsInstalled ? 1 : 2,
        type: {
          feed_id: feed.id,
          num: index + 1,
          video_Source: growthTestData?.dataSource,
          video_tag: videoReportFormat(feed?.feedRecommendReason) || null,
          jump_miniApp: getMiniAppReportValue(EMiniAppPosition.recommendVideo),
        },
      });

      report('call.app.popup.exposure', {
        type: {
          collection_id: '',
          micro_drama_id: '',
          play_status: isFullScreen ? 2 : 1,
          clk_position: 'recommend.open',
        },
      });
    },
    openApp(jump: boolean) {
      const { isWsInstalled, isFullScreen } = state;
      if (jump) {
        report('jump.weishi.click', {
          is_pull_pos: isWsInstalled ? 1 : 2,
          type: {
            jump_miniApp: getMiniAppReportValue(EMiniAppPosition.jumpWeishi),
            collection_id: '',
            micro_drama_id: '',
            play_status: isFullScreen ? 2 : 1,
            pull_pos: 3,
          },
        });

        report('call.app.popup.exposure', {
          type: {
            collection_id: '',
            micro_drama_id: '',
            play_status: isFullScreen ? 2 : 1,
            clk_position: 'recommend.open',
          },
        });
      } else {
        report('recommend.open.click');
      }
    },
    report(key: string, extraTypeParams?: IHashMap<any>) {
      return report(key, extraTypeParams);
    },
    init() {
    },
  };
  return recFeedsReport;
};
